import { defineComponent as _defineComponent } from 'vue'
import Http from '@/core/http/http.service';
import BasketLineItemB2B from '@/ui/views/checkout/BasketLineItemB2B.vue';
import _ from 'lodash';
import { onMounted, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemsB2B',
  props: {
    lineItems: null
  },
  setup(__props: any) {

const props = __props as {lineItems: LineItemViewObject[]}



const asyncDone = ref<boolean>(false);
const salesInfo = ref<SalesInfoViewModel>(null);

onMounted(updateSalesInfo);

watch(() => props.lineItems, onLineItemChange, { deep: true, immediate: true });

function onLineItemChange() {
    if (!salesInfo.value) { return; }

    props.lineItems.forEach((lineItem) => {
        const row = salesInfo.value.variants.find((x) => x.variantId == lineItem.orderNumber);
        if (!row) {
            updateSalesInfo();
        }
    });
}

function updateSalesInfo() {
    const request: SalesInfoWebRequest = {
        sapIds: _.uniq(props.lineItems.map(function(x) { return x.orderNumber; }))
    };

    Http.post('salesinfo/salesinfo', request).then((response: SalesInfoViewModel) => {
        salesInfo.value = response;
        asyncDone.value = true;
    });
}

function getSalesInfo(lineItem: LineItemViewObject): SalesInfoViewObject {
    if (salesInfo.value) { return salesInfo.value.variants.find((x) => lineItem.orderNumber == x.variantId); }
}

return { __sfc: true,props, asyncDone, salesInfo, onLineItemChange, updateSalesInfo, getSalesInfo, BasketLineItemB2B }
}

})